import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, Output } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

import { GroupService } from "../../Services/group.service";
import { SharedService } from "../../Services/sharedService";
import { promise } from "protractor";
import { ProjectService } from "src/app/Services/project.service";
import * as M from "materialize-css/dist/js/materialize";
import { TourConfigService } from "src/app/Services/tour-config.service";
import { DummyDataService } from "src/app/Services/dummy-data.service";
import { Team } from "src/app/interface/teams";
import { ModalService } from "src/app/Services/modal.service";
import { TokenEncryptionService } from "src/app/Services/token-encryption.service";
import { AddProjectComponent } from "./add-project/add-project.component";
import { EntitlementsService } from "src/app/Services/entitlements.service";
import { Subscription } from "rxjs";
import { MatDialog } from "@angular/material/dialog";
import { PlanUpgradeDialogComponent } from "src/app/components/plan-upgrade-dialog/plan-upgrade-dialog.component";


declare var $;
@Component({
  selector: "app-projects",
  templateUrl: "./projects.component.html",
  styleUrls: ["./projects.component.css"],
  standalone: false
})
export class ProjectsComponent implements OnInit, OnDestroy {
  isAdmin = false;
  groupList: any;
  loading = false;
  currentUser: any = {};
  teamData;
  selectedTeam: any;
  searchArr: any = [];
  isdata = false;
  selectData: any;
  isTeamModal = false;
  isShowingDemoData: boolean = false;
  canAddTeam = true;
  teamLimitMessage = '';
  searchQuery: string = '';
  private entitlementsSub?: Subscription;
  private isModalOpening = false;

  constructor(
    private _modalService: ModalService,
    public _projectService: ProjectService,
    private _router: Router,
    private _sharedService: SharedService,
    private cdr: ChangeDetectorRef,
    private _dummyDataService: DummyDataService,
    private tokenEncryptionService: TokenEncryptionService,
    private entitlementsService: EntitlementsService,
    private dialog: MatDialog,
    private route: ActivatedRoute
  ) {
    this.isTeamModal = false;
    this.currentUser = this.tokenEncryptionService.getEncryptedItem<any>('logedInUser') || {};
    this.getUSer();
    this.checkIfCompanyHasRealUsers();
    _projectService.dashboardTourActive.subscribe((value: any) => {
      this.getTeam();
    })
    this._projectService.EmployeeList.subscribe((value) => {
      this.getTeam();
    });
    this._projectService.deleteTeamList.subscribe((data) => {
      this.getTeam();
    })
    $(document).ready(function () {
      $(".fixed-action-btn").floatingActionButton();
      $(".tooltipped").tooltip();
      let promise = Notification.requestPermission()
        .then((res) => {
          // this.loading=false;
        })
        .catch((err) => { });
      // wait for permission
    });
    this._projectService.selsectedTeam.subscribe((res) => {
      this.teamData = res.data;
      this.selectData = res.data;
      this.getTeam();
    })
  }
  ngOnInit() {
    this.syncTeamLimitState();
    this.entitlementsSub = this.entitlementsService.stateChanged$.subscribe(() => {
      this.syncTeamLimitState();
    });

    this.route.queryParams.subscribe(params => {
      // Search
      const search = params['search'] || '';
      if (this.searchQuery !== search) {
        this.searchQuery = search;
        this.searchTeams(search, false); // false to avoid recursive URL update
      }

      // Add Team Modal
      if (params['addTeam'] === 'true' && !this.isModalOpening) {
        if (!this._modalService.isAlreadyOpenDialog(AddProjectComponent)) {
          this.isModalOpening = true;
          this.openUserModal(false);
          this.isModalOpening = false;
        }
      }

      // Edit Team Modal
      const editTeamId = params['editTeam'];
      if (editTeamId && !this.isModalOpening) {
        if (!this._modalService.isAlreadyOpenDialog(AddProjectComponent)) {
          this.isModalOpening = true;
          this.openTeamEditModal(editTeamId);
          this.isModalOpening = false;
        }
      }

      // Selected Team
      const selectedTeamId = params['selectedTeam'];
      if (selectedTeamId && this.searchArr?.length > 0) {
        const team = this.searchArr.find((t: any) => t.id == selectedTeamId);
        if (team && (!this.teamData || this.teamData.id != team.id)) {
           this.handleDataFromTeamMem(team, false);
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.entitlementsSub?.unsubscribe();
  }

  private syncTeamLimitState(): void {
    this.canAddTeam = this.entitlementsService.canCreateTeam();
    this.teamLimitMessage = this.entitlementsService.getTeamLimitMessage();
  }

  ngAfterViewInit() {
  }

  ngAfterContentInit(): void {
    M.AutoInit();
  }

  getUSer() {
    let roleArr = [];
    this._projectService.getUser().subscribe((data: any) => {

      this.tokenEncryptionService.setEncryptedItem('user', data);
      this.entitlementsService.syncFromUser(data);
      this.syncTeamLimitState();

      let isExpired = this._sharedService.checkPlanExpired(data)

      if (isExpired) {
        this._router.navigateByUrl('/plan-expired');
      }
      roleArr = data.role;

      let adminRole = roleArr.filter((ele) => {
        return (ele.toLowerCase().includes("admin") || ele.toLowerCase().includes("company"));
      })

      if (adminRole.length == 0) {
        this.isAdmin = false;
      } else {
        this.isAdmin = true;
      }
    })
  }

  checkIfCompanyHasRealUsers() {
    this._projectService.getUserList(0, 0).subscribe(
      async (users: any) => {
        const hasRealUsers = Array.isArray(users) && users.length > 0;
        if (hasRealUsers) {
          this.isShowingDemoData = false;
          this._dummyDataService.clearLegacySampleMode();
        } else {
          this.isShowingDemoData = await this._dummyDataService.shouldUseLegacySampleFallback(true);
        }
        this.getTeam();
      },
      async () => {
        this.isShowingDemoData = await this._dummyDataService.shouldUseLegacySampleFallback(true);
        this.getTeam();
      }
    );
  }

  async getTeam() {
    this.loading = true;
    if (this.isTourActive()) {
      this._projectService.getTeamList().subscribe(
        async (team: any) => {
          this.loading = false;
          if (team.length == 0) {
            this.teamData = [];
            // When company has real users, show blank teams instead of dummy data
            if (!this.isShowingDemoData) {
              this.groupList = [];
              this.searchArr = [];
            } else {
              const isShowDemoData = await this._dummyDataService.checkIsAvailableDemoData<Team[]>('TeamList');

              if (isShowDemoData.status && isShowDemoData.data && this.isShowingDemoData) {
                this.groupList = isShowDemoData.data;
                this.searchArr = this.groupList;
              } else {
                this.groupList = [];
                this.searchArr = this.groupList;
              }
            }
          } else {
            // Never replace a successful non-empty teams API response with fixtures.
            this.groupList = team;
            this.searchArr = this.groupList;
            this.isShowingDemoData = false;
            this._dummyDataService.setDemoDataVisible(false);
          }
          this.applySearch();
        },
        async (err) => {
          this.loading = false;
          // When company has real users, show blank teams instead of dummy data
          if (!this.isShowingDemoData) {
            this.teamData = [];
            this.groupList = [];
            this.searchArr = [];
          } else {
            const isShowDemoData = await this._dummyDataService.checkIsAvailableDemoData<Team[]>('TeamList');
            let team = [];
            if (isShowDemoData.status && isShowDemoData.data && this.isShowingDemoData) {
              team = isShowDemoData.data;
            } else {
              team = [];
            }
            this.teamData = [];
            this.groupList = team;
            this.searchArr = team;
          }
          this.applySearch();
        }
      );
    } else {
      // When company has real users, show blank teams instead of dummy data
      if (!this.isShowingDemoData) {
        this.teamData = [];
        this.groupList = [];
        this.searchArr = [];
      } else {
        const isShowDemoData = await this._dummyDataService.checkIsAvailableDemoData<Team[]>('TeamList');
        let team = [];
        if (isShowDemoData.status && isShowDemoData.data && this.isShowingDemoData) {
          team = isShowDemoData.data;
        } else {
          team = [];
        }
        this.teamData = [];
        this.groupList = team;
        this.searchArr = team;
      }
      this.loading = false;
      this.applySearch();
    }
  }

  private applySearch() {
    if (this.searchQuery && this.searchArr && this.searchArr.length > 0) {
      this.searchTeams(this.searchQuery, false);
    }
  }

  isTourActive() {
    if (localStorage.getItem('isTour')) {
      if (localStorage.getItem('isTour') == 'false') {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  openTeamEditModal(teamId: string | number) {
    let obj = {
      teamId: teamId,
    };
    if (this._modalService.isAlreadyOpenDialog(AddProjectComponent)) {
      this._modalService.closeDialogIfOpen(AddProjectComponent)
    }
    const dialogRef = this._modalService.openCommonMatDialog(AddProjectComponent, {
      className: 'add-project-modal',
      disableClose: false,
      componentData: obj,
      maxHeight: '90vh',
    });
    dialogRef.afterClosed().subscribe(() => {
      this._router.navigate([], {
        relativeTo: this.route,
        queryParams: { editTeam: null },
        queryParamsHandling: 'merge',
        replaceUrl: true
      });
    });
  }

  openUserModal(updateUrl = true) {
    if (!this.entitlementsService.canCreateTeam()) {
      const ref = this.dialog.open(PlanUpgradeDialogComponent, {
        width: '420px',
        maxWidth: '94vw',
        data: {
          title: 'Team limit reached',
          message: this.entitlementsService.getTeamLimitMessage(),
        },
      });
      ref.afterClosed().subscribe((confirmed) => {
        if (confirmed) {
          void this._router.navigate(['/billings'], { queryParams: { intent: 'upgrade' } });
        }
      });
      return;
    }

    if (updateUrl) {
      this._router.navigate([], {
        relativeTo: this.route,
        queryParams: { addTeam: 'true' },
        queryParamsHandling: 'merge',
        replaceUrl: true
      });
    }

    this.isTeamModal = true;
    if (this._modalService.isAlreadyOpenDialog(AddProjectComponent)) {
      this._modalService.closeDialogIfOpen(AddProjectComponent)
    }

    const dialogRef = this._modalService.openCommonMatDialog(AddProjectComponent, {
      className: 'add-project-modal',
      disableClose: false,
      maxHeight: '90vh',
    });

    dialogRef.afterClosed().subscribe(() => {
      this._router.navigate([], {
        relativeTo: this.route,
        queryParams: { addTeam: null },
        queryParamsHandling: 'merge',
        replaceUrl: true
      });
    });
  }

  handleDataFromTeamMem(data: any, updateUrl = true) {
    if (!data) {
      this.teamData = [];
    } else {
      this.teamData = data;
      this.selectedTeam = data;
    }

    if (updateUrl && data && data.id) {
      this._router.navigate([], {
        relativeTo: this.route,
        queryParams: { selectedTeam: data.id },
        queryParamsHandling: 'merge',
        replaceUrl: true
      });
    }
  }

  searchTeams(val: any, updateUrl = true) {
    let svalue = (val || '').toUpperCase();
    this.searchQuery = val;
    this.groupList = this.searchArr.filter((ele) => {
      return (ele.title.rendered.toUpperCase().includes(svalue));
    });

    if (updateUrl) {
      this._router.navigate([], {
        relativeTo: this.route,
        queryParams: { search: val || null },
        queryParamsHandling: 'merge',
        replaceUrl: true
      });
    }
  }
}
